import { ReactNode } from 'react'

import {
  Text,
  BorderRadius6,
  GreyGrey20,
  GreyGrey70,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular,
  Center,
  Flex
} from '@sequencehq/core-components'

type Props = {
  title: string
  body?: string | ReactNode
  icon: ReactNode
  iconBackground?: string
  action?: ReactNode
  showActionOnHover?: boolean
  hideBorderBottom?: boolean
  'data-testid'?: string
}

export const RowControl = ({
  title,
  body,
  icon,
  iconBackground = GreyGrey20,
  action,
  showActionOnHover = false,
  hideBorderBottom = false,
  'data-testid': dataTestId
}: Props) => {
  return (
    <Flex
      borderBottom={hideBorderBottom ? undefined : `${GreyGrey20} 1px solid`}
      paddingY="16px"
      gap="16px"
      alignItems="top"
      className="group"
      data-testid={dataTestId}
    >
      <Center
        width="32px"
        height="32px"
        background={iconBackground}
        borderRadius={BorderRadius6}
        overflow="hidden"
        color={GreyGrey70}
        marginY="1px"
        flexShrink="0"
      >
        {icon}
      </Center>

      <Flex flexDir="column" gap="2px" flex="1" justifyContent="center">
        <Text {...Primary13SemiBold} color={GreyGrey80}>
          {title}
        </Text>

        {typeof body === 'string' ? (
          <Text {...Primary13Regular} color={GreyGrey80} whiteSpace="pre-wrap">
            {body}
          </Text>
        ) : (
          body
        )}
      </Flex>

      {action && (
        <Flex
          alignItems="center"
          {...(showActionOnHover
            ? {
                opacity: 0,
                _groupHover: { opacity: 1 },
                transition: 'opacity 250ms'
              }
            : {})}
        >
          {action}
        </Flex>
      )}
    </Flex>
  )
}
